import React, { useState, useEffect } from "react";
import "./SideNav.css";
import { Image, Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Navigation } from 'CommonComponent';

const SideNav = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState([]);

  const session = useSelector((state) => state.session);

  // Function to determine the active keys based on the current URL
  const getActiveKeysForUrl = (url, menuData) => {
    const activeKeys = [];

    // Map view/detail routes to their corresponding list routes so parents open
    const aliasParentRoutes = {
      monthlyappraisalview: "appraisal",
      monthlyappraisalreport: "monthly-reports",
      appraisalprogressform: "appraisal",
      quarterlyappraisalview: "quarterly-appraisal",
      "quarterly-appraisal/view": "quarterly-appraisal",
      "quarterly-appraisal/paf/view": "quarterly-appraisal",
      yearlyappraisalview: "yearly-appraisals",
      "yearly-appraisals/view": "yearly-appraisals",
      "yearly-appraisals/paf/view": "yearly-appraisals",
      "probationary-appraisals/view": "probationary-appraisals",
      "probational-appraisals/view": "probationary-appraisals",
      "appraisalSetup/add": "appraisalSetup",
      "appraisalSetup/update": "appraisalSetup",
      "appraisalSetup/view": "appraisalSetup",
      setupCategory: "appraisalSetup",
    };

    const menuRouteAliases = {
      monthlyappraisals: "appraisal",
      quarterlyappraisals: "quarterly-appraisal",
      yearlyappraisals: "yearly-appraisals",
    };

    const findParents = (routeUrl, items, parentKeys = []) => {
      for (const item of items) {
        const rawHref = item.href ? item.href.replace(/^\//, "") : "";
        const normalizedHref = menuRouteAliases[rawHref] || rawHref;
        const isExactOrChild =
          !!normalizedHref &&
          (routeUrl === normalizedHref || routeUrl.startsWith(`${normalizedHref}/`));

        if (
          isExactOrChild ||
          (item.children && findParents(routeUrl, item.children, [...parentKeys, item.id]))
        ) {
          activeKeys.push(...parentKeys, item.id);
          return true;
        }
      }
      return false;
    };

    if (menuData) {
      const pathWithoutSlash = String(url || "").replace(/^\//, "");
      let effectiveUrl = pathWithoutSlash;

      if (
        pathWithoutSlash === "appraisalprogressform" ||
        pathWithoutSlash.startsWith("appraisalprogressform/")
      ) {
        const from = location.state?.from;
        effectiveUrl = from
          ? String(from).replace(/^\//, "")
          : "appraisal";
      } else {
        for (const [alias, parentRoute] of Object.entries(aliasParentRoutes)) {
          if (pathWithoutSlash === alias || pathWithoutSlash.startsWith(`${alias}/`)) {
            effectiveUrl = parentRoute;
            break;
          }
        }
      }

      findParents(effectiveUrl, menuData);
    }

    return activeKeys;
  };

  useEffect(() => {
    if (session.nested_menus) {
      const activeKeys = getActiveKeysForUrl(location.pathname.replace(/^\//, ''), session.nested_menus);
      setActiveKey(activeKeys);
    }
  }, [location.pathname, session.nested_menus]);

  // Handler for multi-open
  const handleSelect = (key) => {
    setActiveKey((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  return (
    <div className={`sideNav ${isOpen ? "open" : "closed"}`}>
      {/* Header: Logo + Toggle Button */}
      <div className="d-flex justify-content-between align-items-center mb-5">
        <Link
          to="/dashboard"
          className="sidebar-dashboard-link"
          aria-label="Open dashboard"
          title="Dashboard"
        >
          <Image
            src={isOpen ? "/assets/images/NX-logo.svg" : "/assets/images/nx.svg"}
            alt="Premier NX"
            className="sidebar-logo"
          />
        </Link>
        <button
          type="button"
          className="sidebar-toggle-btn border-0 bg-transparent p-0"
          onClick={toggleSidebar}
          aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
          aria-expanded={isOpen}
        >
          <Image
            src={
              isOpen
                ? "/assets/images/menu-collapse.svg"
                : "/assets/images/menu-expand.svg"
            }
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
      <div>
        <div className="accordian-parent">
          <Accordion
            activeKey={activeKey}
            onSelect={handleSelect}
            className="custom-accordion"
            alwaysOpen
          >
            {session.nested_menus &&
              <Navigation
                component="div"
                pages={session.nested_menus}
                isMenuCollapse={isOpen}
                setActiveKey={setActiveKey}
                activeKey={activeKey}
                onSelect={handleSelect}
              />
            }
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
